<div id="add-review-comments" class="add-review-comments row">
    <div id="{{appName}}-app" class="col-7 float-right ml-auto review-comment-content">
        <mat-card style="margin: 15px 15px 30px 15px;" [ngStyle]="{'visibility':reviewCommentList.length>0?'visible':'hidden'}">
            <div class="example-button-container float-right ml-auto" [ngStyle]="{'visibility':reviewCommentList.length>0?'visible':'visible'}">
                <button matTooltip="Review Comments" *ngIf="reviewCommmentLength === 0" (click)="openReviewCommentsPopup();" color="warn"
                    class="review-comment-icon" mat-fab aria-label="Example icon button with a heart icon">
                    <span class="fa fa-comments" aria-hidden="true" style="font-size: 30px;"></span>
                </button>

                <button matTooltip="Review Comments" *ngIf="reviewCommmentLength > 0" [matBadge]="reviewCommmentLength" matBadgeColor="warn"
                    (click)="openReviewCommentsPopup();" color="warn" class="review-comment-icon" mat-fab aria-label="Example icon button with a heart icon">
                    <span class="fa fa-comments" aria-hidden="true" style="font-size: 30px;"></span>
                </button>
            </div>
        </mat-card>
    </div>
</div>